import styled from 'styled-components';

import { AUTH_STACKED_LAYOUT_MAX_WIDTH_PX } from '../../routes/auth/auth.tokens';

export const AuthWrapper = styled.div`
    display: flex;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
`;

export const AuthBody = styled.div`
    flex: 1;
    min-width: 0;
    min-height: 100vh;
    background-color: ${({ theme }) => theme.background?.default};
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 50px 32px;

    @media (max-width: ${AUTH_STACKED_LAYOUT_MAX_WIDTH_PX}px) {
        padding: 32px 16px;
    }
`;
